import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globle } from 'src/assets/globle';
import { LocalStorageService } from 'ngx-webstorage';
import { CategoryPermission } from './categoryPermission.model';

@Injectable({
  providedIn: 'root'
})
export class CategorypermissionService {



  constructor(private http: HttpClient, private global: Globle,
    private localStorage: LocalStorageService) {


  }

  getByUser(userid: string) {
    return this.http.get<CategoryPermission[]>(this.global.APIURLV2 +
      "categorypermission/getbyuser/" + userid);
  }

  Create(obj: any) {
    return this.http.post<any>(this.global.APIURLV2 + "categorypermission/create", obj)
  }
}
